import lookups from '@/assets/json/clientLookups.json'
import { useFormStore } from '@/stores/form'
import { notify } from 'notiwind'
import i18n from '@/i18n/i18n'
import router from '@/router'

const doNotify = (title, text, duration = 6000, group = 'error') => {
  notify(
    {
      group: group,
      title,
      text
    },
    duration
  )
}

export default async function () {
  const formStore = useFormStore()
  const {
    isInCompleteDraftFlag,
    enableNominationRequest,
    hideNominationInfoForSelectedReason,
    isNominationRequestValid
  } = formStore.extraMap
  const { applyVisaByNominationRequest } = formStore.form.values

  if (
    enableNominationRequest &&
    !hideNominationInfoForSelectedReason &&
    !isNominationRequestValid &&
    !isInCompleteDraftFlag &&
    applyVisaByNominationRequest != 2
  ) {
    doNotify(i18n.t('warningTitle'), i18n.t('checkNominationRequestBefore'))
    return false
  }

  return true
}
